import { useMutation } from '@tanstack/react-query'
import { postToken } from '@/apis/Befehlsnachricht'
import { Befehlsnachricht } from '@/models/Befehlsnachricht'

export interface BfnTokenAbrufData {
  zugnummer: Befehlsnachricht['zugnummer']
  zugriffscode: string
}

export function useBfnTokenAbrufMutation() {
  const mutation = useMutation({
    mutationFn: async ({ zugnummer, zugriffscode }: BfnTokenAbrufData) => {
      return postToken(zugnummer, zugriffscode)
    }
  })

  return { mutation }
}
